import CookiesNotice from '@/js/components/cookies/cookies';
import guardScrollLock from '@/js/components/cookies/scrollLock';

const cookiesNoticeEl = document.getElementById('cookies-notice');
const cookiesNoticeModal = document.getElementById('cookie-customizer-modal');

// Never leave the page scroll locked when the notice can no longer be used
guardScrollLock();

// Cookies notice
if (cookiesNoticeEl || cookiesNoticeModal) {
  // eslint-disable-next-line no-new
  new CookiesNotice(cookiesNoticeEl, cookiesNoticeModal);
}
